const ProductGenderSizeInitialValues = () => ({
  product_id: null,
  gender_id: null,
  product_size_id: null,
});

export default ProductGenderSizeInitialValues;
